import { Accounts, UserInfo } from "./PlatformActions";
import { stringFromErrorOrAny } from "../utils/tools";
import { App } from "../app";

export function processSignInPromise(promise: Promise<Accounts | UserInfo | null>, isNotification: boolean): void {
    promise.then((result: Accounts | UserInfo | null) => {
        if (result == null) {
            App.signInPrompt(isNotification);
            return;
        }

        let users: UserInfo[];
        if ((result as Accounts).users) { // if Accounts type
            users = (result as Accounts).users;
        }
        else {
            users = [result as UserInfo];
        }

        if (users.length === 0) {
            App.signInPrompt(isNotification);
            return;
        }

        App.chooseAccountIfNeeded(users, isNotification);
    }).catch(err => {
        App.signInFailed(stringFromErrorOrAny(err), isNotification);
    });
}
